import React, { useContext } from 'react'
import { Link } from "react-router-dom";
import authContext from "../../../context/auth/authContext";

const Header = () => {
    const AuthContext = useContext(authContext);
    const { logout } = AuthContext;
    const { toggle_sidebar } = AuthContext;


    const userInfo = JSON.parse(localStorage.getItem('userInfo'));

    return (
        <header className="topbar-nav">
            <nav className="navbar navbar-expand fixed-top bg-white">
                <ul className="navbar-nav mr-auto align-items-center">
                    <li className="nav-item" onClick={toggle_sidebar}>
                        <div className="nav-link toggle-menu" >
                            <i className="icon-menu menu-icon"></i>
                        </div>
                    </li>
                    <li className="nav-item">
                        <form className="search-bar">
                            <input type="text" className="form-control" placeholder="Enter keywords"/>
                            <a href="#!"><i className="icon-magnifier"></i></a>
                        </form>
                    </li>
                </ul>

                <ul className="navbar-nav align-items-center right-nav-link">
                    <li className="nav-item dropdown-lg">
                        <a className="nav-link dropdown-toggle dropdown-toggle-nocaret waves-effect"
                           data-toggle="dropdown"
                           href="#!">
                            <i className="fa fa-envelope-open-o"></i><span
                            className="badge badge-secondary badge-up">12</span></a>
                        <div className="dropdown-menu dropdown-menu-right">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                    You have 12 new messages
                                    <span className="badge badge-secondary">12</span>
                                </li>
                                <li className="list-group-item">
                                    <a href="#!">
                                        <div className="media">
                                            <div className="avatar"><img className="align-self-start mr-3"
                                                                         src="images/avatars/avatar-5.png"
                                                                         alt="user avatar"/></div>
                                            <div className="media-body">
                                                <h6 className="mt-0 msg-title">Jhon Deo</h6>
                                                <p className="msg-info">Lorem ipsum dolor sit amet...</p>
                                                <small>Today, 4:10 PM</small>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li className="list-group-item">
                                    <a href="#!">
                                        <div className="media">
                                            <div className="avatar"><img className="align-self-start mr-3"
                                                                         src="assets/images/avatars/avatar-6.png"
                                                                         alt="user avatar"/></div>
                                            <div className="media-body">
                                                <h6 className="mt-0 msg-title">Sara Jen</h6>
                                                <p className="msg-info">Lorem ipsum dolor sit amet...</p>
                                                <small>Yesterday, 8:30 AM</small>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li className="list-group-item">
                                    <a href="#!">
                                        <div className="media">
                                            <div className="avatar"><img className="align-self-start mr-3"
                                                                         src="assets/images/avatars/avatar-7.png"
                                                                         alt="user avatar"/></div>
                                            <div className="media-body">
                                                <h6 className="mt-0 msg-title">Dannish Josh</h6>
                                                <p className="msg-info">Lorem ipsum dolor sit amet...</p>
                                                <small>5/11/2018, 2:50 PM</small>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li className="list-group-item">
                                    <a href="#!">
                                        <div className="media">
                                            <div className="avatar"><img className="align-self-start mr-3"
                                                                         src="assets/images/avatars/avatar-8.png"
                                                                         alt="user avatar"/></div>
                                            <div className="media-body">
                                                <h6 className="mt-0 msg-title">Katrina Mccoy</h6>
                                                <p className="msg-info">Lorem ipsum dolor sit amet.</p>
                                                <small>1/11/2018, 2:50 PM</small>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li className="list-group-item"><a href="#!">See All Messages</a></li>
                            </ul>
                        </div>
                    </li>
                    <li className="nav-item dropdown-lg">
                        <a className="nav-link dropdown-toggle dropdown-toggle-nocaret waves-effect"
                           data-toggle="dropdown"
                           href="#!">
                            <i className="fa fa-bell-o"></i><span className="badge badge-info badge-up">14</span></a>
                        <div className="dropdown-menu dropdown-menu-right">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                    You have 14 Notifications
                                    <span className="badge badge-info">14</span>
                                </li>
                                <li className="list-group-item">
                                    <a href="#!">
                                        <div className="media">
                                            <i className="zmdi zmdi-accounts fa-2x mr-3 text-primary"></i>
                                            <div className="media-body">
                                                <h6 className="mt-0 msg-title">New Registered Users</h6>
                                                <p className="msg-info">Lorem ipsum dolor sit amet...</p>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li className="list-group-item">
                                    <a href="#!">
                                        <div className="media">
                                            <i className="zmdi zmdi-coffee fa-2x mr-3 text-success"></i>
                                            <div className="media-body">
                                                <h6 className="mt-0 msg-title">New Received Orders</h6>
                                                <p className="msg-info">Lorem ipsum dolor sit amet...</p>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li className="list-group-item">
                                    <a href="#!">
                                        <div className="media">
                                            <i className="zmdi zmdi-notifications-active fa-2x mr-3 text-secondary"></i>
                                            <div className="media-body">
                                                <h6 className="mt-0 msg-title">New Updates</h6>
                                                <p className="msg-info">Lorem ipsum dolor sit amet...</p>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li className="list-group-item"><a href="#!">See All Notifications</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link dropdown-toggle dropdown-toggle-nocaret" data-toggle="dropdown" href="#!">
              <span className="user-profile"><img src={userInfo.passport} className="img-circle"
                                                  alt="user avatar"/></span>
                        </a>
                        <ul className="dropdown-menu dropdown-menu-right">
                            <li className="dropdown-item user-details">
                                <a href="#!">
                                    <div className="media">
                                        <div className="avatar"><img className="align-self-start mr-3"
                                                                     src={userInfo.passport}
                                                                     alt="user avatar"/></div>
                                        <div className="media-body">
                                            <h6 className="mt-2 user-title">{userInfo.first_name}</h6>
                                            <p className="user-subtitle">{userInfo.email}</p>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li className="dropdown-divider"></li>
                            <li className="dropdown-divider"></li>
                            <li className="dropdown-item" onClick={logout}><Link to="/"><i
                                className="icon-power mr-2"></i> Logout</Link></li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </header>
    )
};


export default Header;